import '../styles/pages/ServiceTwo.scss';
import serviceTwoBanner from '../assets/service2.svg'
import serviceTwoBannerMobile from '../assets/phone/domiciliation.svg'
import bannerBG2 from '../assets/banner-bg2.svg';
import batiment from '../assets/icons/batiment.svg'
import cout from'../assets/icons/cout.svg'
import horloge from '../assets/icons/horloge.svg'
import facture from '../assets/icons/facture-dachat.svg'
import partner from '../assets/icons/partenariat.svg'
import serviceClient from '../assets/icons/service-clients.svg'
import maison from '../assets/icons/maison.svg'
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ServiceTwo = () => {
    const { t } = useTranslation();
    return(
        <div className='main-container'>
            <div className='de-header'>
                <h1> {t('serviceTwo.header')} </h1>
            </div>
            <div className='de-intro'>
                <ul>
                    <li> {t('serviceTwo.intro.p1')} </li>
                    <li> {t('serviceTwo.intro.p2')} </li>
                </ul>
                <div className='de-intro-image'>
                    <img src={window.innerWidth > 768 ? serviceTwoBanner : serviceTwoBannerMobile} alt="Création d'entreprise" className='img-banner' />
                    <img src={bannerBG2} alt='background 2' className='background2' />
                </div> 
            </div>
            <div className='dm-services-container'>
                <h2> {t('serviceTwo.advantages.title')} </h2>
                <div className='dm-services'>
                    <div className='dm-service-card'>
                        <img src={batiment} alt='Choix flexible' />
                        <h3> {t('serviceTwo.advantages.a1.title')} </h3>
                        <p> {t('serviceTwo.advantages.a1.description')} </p>
                    </div>
                    <div className='dm-service-card'>
                        <img src={horloge} alt='Gain de temps' />
                        <h3> {t('serviceTwo.advantages.a2.title')} </h3>
                        <p> {t('serviceTwo.advantages.a2.description')} </p>
                    </div>
                    <div className='dm-service-card'>
                        <img src={cout} alt='Tarifs négociés' />
                        <h3> {t('serviceTwo.advantages.a3.title')} </h3>
                        <p> {t('serviceTwo.advantages.a3.description')} </p>
                    </div>
                </div>
            </div>
            <div className="dm-how-it-works">
                <h2>{t('serviceTwo.howItWorks.title')}</h2>
                <div className="steps-timeline">
                    <div className="step">
                        <div className="circle">1</div>
                        <div className="step-text">{t('serviceTwo.howItWorks.step1')}</div>
                    </div>
                    <div className="step">
                        <div className="circle">2</div>
                        <div className="step-text">{t('serviceTwo.howItWorks.step2')}</div>
                    </div>
                    <div className="step">
                        <div className="circle">3</div>
                        <div className="step-text">{t('serviceTwo.howItWorks.step3')}</div>
                    </div>
                    <div className="step last">
                        <div className="circle">4</div>
                        <div className="step-text">{t('serviceTwo.howItWorks.step4')}</div>
                    </div>
                </div>
            </div>
            <div className='dm-other'>
                <div className='dm-other-card'>
                    <img src={partner} alt='' />
                    <span> {t('serviceTwo.other.o1')} </span>
                </div>
                <div className='dm-other-card'>
                    <img src={facture} alt='' />
                    <span> {t('serviceTwo.other.o2')} </span>
                </div>
                <div className='dm-other-card'>
                    <img src={serviceClient} alt='' />
                    <span> {t('serviceTwo.other.o3')} </span>
                </div>
            </div>
            <div className='dm-footer'>
                <img src={maison} alt='maison' />
                <Link to="/contact">
                    <button> {t('serviceTwo.footer.button')} </button>
                </Link>
                
            </div>
        </div>
    )
}

export default ServiceTwo;
